import { Component, Inject, inject } from '@angular/core';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  image: File;
  ratio: number;
}
@Component({
  selector: 'app-cropper-dialog',
  templateUrl: './cropper-dialog.component.html',
})
export class CropperDialogComponent {
  result!: any;
  showCropper = false;
  scale = 1;
  transform: ImageTransform = {
    // translateUnit: 'px'
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<CropperDialogComponent>
  ) { }

  imageLoaded() {
    this.showCropper = true;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.result = event;
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  saveImage() {
    this.dialogRef.close(this.result);
  }
}
